import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { LogService } from '../../../../core/services/log.service';
// import { EventGuestsService } from '../../services/event-guests.service';

import IdentificationTypesListPageView from "./identification-types-list.page.html";

@Component({
    selector: 'identification-types-list-page',
    template: IdentificationTypesListPageView
})

export class IdentificationTypesListPage implements OnInit {

    isAllowed: boolean = false;

    constructor(@Inject(AuthService) private authService: AuthService,
        @Inject(LogService) private log: LogService,
        @Inject('$stateParams') private $stateParams: any) {

    }

    ngOnInit() {
        this.isAllowed = this.authService.permissionExist('IDENTIFICATION_TYPES_READ') ?? false;
    }

}